import { TaskView } from '@nexelem/graphne-api';

export const getProductionOrderNumber = (task: TaskView): string | undefined =>
  task.qapsSimulationData?.productionOrderIdentifier ||
  task.productionOrderDetails?.externalId ||
  task.productionOrderDetails?.number;
